import { PageType } from 'types/analytics'
import { OutletBrand, ShopBrand } from 'types/brands'
import {
	Channel,
	Device,
	Environment,
	type MasterData,
	Platform,
} from 'types/masterData'

const brandTranslationKeys = {
	[ShopBrand.she]: {
		labelKey: 'line.woman.she.text',
		urlKey: 'shop.url.home.she',
	},
	[ShopBrand.he]: { labelKey: 'line.man.he.text', urlKey: 'shop.url.home.he' },
	[ShopBrand.kids]: {
		labelKey: 'line.kids.text',
		urlKey: 'shop.url.home.kids',
	},
	[ShopBrand.newBorn]: {
		labelKey: 'line.kids.newBorn.text',
		urlKey: 'shop.url.newborn',
	},
	[ShopBrand.babyNina]: {
		labelKey: 'line.kids.babyNina.text',
		urlKey: 'shop.url.kidsE',
	},
	[ShopBrand.babyNino]: {
		labelKey: 'line.kids.babyNino.text',
		urlKey: 'shop.url.kidsD',
	},
	[ShopBrand.nina]: {
		labelKey: 'line.kids.nina.text',
		urlKey: 'shop.url.kidsA',
	},
	[ShopBrand.nino]: {
		labelKey: 'line.kids.nino.text',
		urlKey: 'shop.url.kidsO',
	},
	[ShopBrand.teen]: {
		labelKey: 'line.teen.text',
		urlKey: 'shop.url.home.teen',
	},
	[ShopBrand.teenA]: {
		labelKey: 'line.teen.teenA.text',
		urlKey: 'shop.url.teenA',
	},
	[ShopBrand.teenO]: {
		labelKey: 'line.teen.teenO.text',
		urlKey: 'shop.url.teenO',
	},
	[ShopBrand.home]: {
		labelKey: 'line.home.text',
		urlKey: 'shop.url.home.home',
	},
	[OutletBrand.outlet]: {
		labelKey: 'line.woman.outlet.text',
		urlKey: 'shop.url.home.outlet',
	},
	[OutletBrand.outletH]: {
		labelKey: 'line.man.outletH.text',
		urlKey: 'shop.url.home.outletH',
	},
	[OutletBrand.outletK]: {
		labelKey: 'line.outletK.text',
		urlKey: 'shop.url.kidsK',
	},
	[OutletBrand.outletA]: {
		labelKey: 'line.kids.girl.outletA.text',
		urlKey: 'shop.url.kidsA',
	},
	[OutletBrand.outletO]: {
		labelKey: 'line.kids.boy.outletO.text',
		urlKey: 'shop.url.kidsO',
	},
	[OutletBrand.outletBA]: {
		labelKey: 'line.kids.babyGirl.outletBA.text',
		urlKey: 'shop.url.kidsE',
	},
	[OutletBrand.outletBO]: {
		labelKey: 'line.kids.babyBoy.outletBO.text',
		urlKey: 'shop.url.kidsD',
	},
	[OutletBrand.outletNB]: {
		labelKey: 'line.kids.newBorn.outletNB.text',
		urlKey: 'shop.url.kidsNB',
	},
	[OutletBrand.outletT]: {
		labelKey: 'form.lines.outletT.checkbox',
		urlKey: 'shop.url.teenT',
	},
	[OutletBrand.outletQ]: {
		labelKey: 'line.teen.outletQ.text',
		urlKey: 'shop.url.teenQ',
	},
	[OutletBrand.outletP]: {
		labelKey: 'line.teen.outletP.text',
		urlKey: 'shop.url.teenP',
	},
	[OutletBrand.outletC]: {
		labelKey: ' line.outletC.text',
		urlKey: 'shop.url.homeC',
	},
}

export const masterDataMock: MasterData = {
	abTestPage: null,
	abTestLayout: null,
	channel: Channel.Shop,
	environment: Environment.Local,
	pageType: PageType.Home,
	brand: null,
	subBrand: null,
	device: Device.Mobile,
	isMainHeadingLogo: false,
	custom: null,
	customDate: null,
	isApp: false,
	platform: Platform.Web,
	isShop: true,
	isMobile: true,
	isDesktop: false,
	userAgent: null,
	isCicd: false,
	isQa: false,
	dev: null,
	referer: null,
	url: 'https://cloudtest.dev.mango.com/es/es',
	region: null,
	test: false,
	country: {
		brands: [
			{
				id: ShopBrand.she,
				labelKey: brandTranslationKeys[ShopBrand.she].labelKey,
				urlKey: brandTranslationKeys[ShopBrand.she].urlKey,
			},
			{
				id: ShopBrand.he,
				labelKey: brandTranslationKeys[ShopBrand.he].labelKey,
				urlKey: brandTranslationKeys[ShopBrand.he].urlKey,
			},
			{
				id: ShopBrand.teen,
				labelKey: brandTranslationKeys[ShopBrand.teen].labelKey,
				urlKey: brandTranslationKeys[ShopBrand.teen].urlKey,
				subBrands: [
					{
						id: ShopBrand.teenA,
						labelKey: brandTranslationKeys[ShopBrand.teenA].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.teenA].urlKey,
					},
					{
						id: ShopBrand.teenO,
						labelKey: brandTranslationKeys[ShopBrand.teenO].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.teenO].urlKey,
					},
				],
			},
			{
				id: ShopBrand.kids,
				labelKey: brandTranslationKeys[ShopBrand.kids].labelKey,
				urlKey: brandTranslationKeys[ShopBrand.kids].urlKey,
				subBrands: [
					{
						id: ShopBrand.nina,
						labelKey: brandTranslationKeys[ShopBrand.nina].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.nina].urlKey,
					},
					{
						id: ShopBrand.nino,
						labelKey: brandTranslationKeys[ShopBrand.nino].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.nino].urlKey,
					},
					{
						id: ShopBrand.babyNina,
						labelKey: brandTranslationKeys[ShopBrand.babyNina].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.babyNina].urlKey,
					},
					{
						id: ShopBrand.babyNino,
						labelKey: brandTranslationKeys[ShopBrand.babyNino].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.babyNino].urlKey,
					},
					{
						id: ShopBrand.newBorn,
						labelKey: brandTranslationKeys[ShopBrand.newBorn].labelKey,
						urlKey: brandTranslationKeys[ShopBrand.newBorn].urlKey,
					},
				],
			},
			{
				id: ShopBrand.home,
				labelKey: brandTranslationKeys[ShopBrand.home].labelKey,
				urlKey: brandTranslationKeys[ShopBrand.home].urlKey,
			},
		],
		additionalCurrencies: undefined,
		mangoISO: 'ES',
		countryISO: 'ES',
		countryCode: 'ES',
		currency: {
			iso: 'EUR',
			isoCode: '978',
			symbol: '€',
			format: '%@ €',
			decimals: 2,
			factor: 1,
		},
		warehouse: {
			defaultId: '001',
			secondaryId: '001',
			showEstimatedDeliveryTime: false,
			showEstimatedDeliveryTimeRange: false,
		},
		languageName: 'Castellano',
		countryName: 'España (Península y Baleares)',
		isMultiLanguage: true,
		hasDiscount: false,
		hasOnlineProducts: true,
		hasOnlineSale: true,
		hasPriceHistory: true,
		isDefaultLanguage: true,
		isDiscountSeason: false,
		shouldShowReleasesMicrofibers: true,
		shouldShowDiscountRate: true,
		isLoyalty: true,
		languageISO: 'es',
		locale: 'es-ES',
		loyalty: {
			likesThresholdReminder: '1000000',
		},
		mngLogo: false,
		refund: {
			enabled: true,
			time: 30,
			i18nKey: 'free',
		},
		shoppingCart: {
			allowedSeasonsForCustomizedProducts: '1,2,3,4,5,6,7,8',
			cartMaxAmount: 1500,
			cartMaxUnits: 40,
		},
		shippingInfo: {
			freeShippingAvailable: true,
			freeShippingMinAmount: 30,
			shipmentPrice: 3.95,
		},
		isRtl: false,
		kcSafetyGenderIds: undefined,
	},
}
